module.exports = __webpack_public_path__ + "img/codicon-book.65111eca.svg";